// extracted by mini-css-extract-plugin
export default {"publicHome":"PublicHome_publicHome__AIJab"};